import AbstractDesktopPlatformNotificationWindow
    from "~/operatorApplication/ts/platform/desktopNotification/AbstractDesktopPlatformNotificationWindow";
import Random from "~/ts/library/Random";
import {ElectronIPCRendererInstance} from "~/ts/library/electron/ipc/ElectronIPCRenderer";
import {
    OPERATOR_ELECTRON_IPC_CLOSE_NOTIFICATION_ACTION,
    OPERATOR_ELECTRON_IPC_CREATE_NOTIFICATION_ACTION,
    OPERATOR_ELECTRON_IPC_MOVE_NOTIFICATION_ACTION,
    OPERATOR_ELECTRON_IPC_RESIZE_NOTIFICATION_ACTION,
    OPERATOR_ELECTRON_IPC_SHOW_NOTIFICATION_ACTION
} from "~/operatorApplication/electron/src/ipc/ElectronIpcActionsConstant";
import ElectronIpcCreateNotificationRequestInterface
    from "~/operatorApplication/electron/src/ipc/ElectronIpcCreateNotificationRequestInterface";
import ElectronIpcResizeNotificationRequestInterface
    from "~/operatorApplication/electron/src/ipc/ElectronIpcResizeNotificationRequestInterface";
import ElectronIpcMoveNotificationRequestInterface
    from "~/operatorApplication/electron/src/ipc/ElectronIpcMoveNotificationRequestInterface";
import PlatformNotificationParamsInterface from "~/operatorApplication/ts/platform/PlatformNotificationParamsInterface";
import ElectronIpcShowNotificationRequestInterface
    from "~/operatorApplication/electron/src/ipc/ElectronIpcShowNotificationRequestInterface";
import {OperatorConfigStore} from "~/operatorApplication/ts/store/OperatorConfigStore";
import {icon} from "~/ts/vuePlugins/IconPlugin";

export default class ElectronPlatformNotificationWindow extends AbstractDesktopPlatformNotificationWindow {
    private windowId: string;

    constructor() {
        super();
        this.windowId = Random.uid();
    }

    async init() {
        let p: ElectronIpcCreateNotificationRequestInterface = {
            id: this.windowId
        };
        await ElectronIPCRendererInstance.invoke(
            OPERATOR_ELECTRON_IPC_CREATE_NOTIFICATION_ACTION,
            p
        );
    }

    protected async applyContentAndDisplay(p: PlatformNotificationParamsInterface): Promise<boolean | number> {
        let showParams: ElectronIpcShowNotificationRequestInterface = {
            id: this.windowId,
            brandId: OperatorConfigStore.brandId.value,
            text: p.text,
            title: p.title,
            icon: p.icon ? JSON.stringify({
                color: p.icon.color,
                imgIcon: p.icon.imgIcon,
                fontAwesomeIcon: icon(p.icon.fontAwesomeIcon)
            }) : null,
            avatarUrl: p.avatarUrl,
            actions: p.actions ? p.actions.map(action => {
                return {
                    title: action.title,
                    id: Random.uid(32),
                    color: action.color
                }
            }) : undefined
        };
        return await ElectronIPCRendererInstance.invoke(
            OPERATOR_ELECTRON_IPC_SHOW_NOTIFICATION_ACTION,
            showParams
        );
    }

    setSize(width: number, height: number) {
        let p: ElectronIpcResizeNotificationRequestInterface = {
            id: this.windowId,
            width,
            height,
            maximized: false
        };
        ElectronIPCRendererInstance.invoke(
            OPERATOR_ELECTRON_IPC_RESIZE_NOTIFICATION_ACTION,
            p
        )
    }

    setPosition(left: number, top: number, animate: boolean) {
        let p: ElectronIpcMoveNotificationRequestInterface = {
            id: this.windowId,
            x: left,
            y: top,
            animate
        };
        ElectronIPCRendererInstance.invoke(
            OPERATOR_ELECTRON_IPC_MOVE_NOTIFICATION_ACTION,
            p
        )
    }

    close() {
        ElectronIPCRendererInstance.invoke(
            OPERATOR_ELECTRON_IPC_CLOSE_NOTIFICATION_ACTION,
            this.windowId
        );
    }
}